// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1q7pW","buttons":"SendReceipts_buttons__26-dh","email":"SendReceipts_email__2H-bE","bookApptTitle":"SendReceipts_bookApptTitle__21f0O"};